import React from 'react';

import { flagStyles } from '../settings';

const SvgTV = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-5376px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgTV;
